export enum SynchronizationStatus {
  Selected = 1,
  RegisteredInEMatica = 2,
  ManuallyEntered = 3,
}
